import styled, { AnyStyledComponent } from "styled-components";
import COLORS from "../../style/universal.color";
import { MLBTheme } from "../../style/theme.types";

const sizes = [0, 40, 35, 30, 25, 20, 15];
export interface HeadlineStyleProps {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  theme: MLBTheme;
}

const getFontSize = ({ level }: HeadlineStyleProps) => {
  return `${sizes[level]}px`;
};

const getFontColor = ({ theme }: HeadlineStyleProps): string =>
  theme.dark ? COLORS.mlbWhite : COLORS.mlbGrey7;

export const HeadlineWrapper: AnyStyledComponent = styled.h1<
  HeadlineStyleProps
>`
  font-family: ${ ({ theme = {}} : HeadlineStyleProps) => theme.fonts?.family?.primary};
  font-size: ${getFontSize};
  color: ${getFontColor};
  h5& {
    font-weight: normal;
  }
  margin: 0;
`;

export const SkeletonWrapper: AnyStyledComponent = styled.div<
  HeadlineStyleProps
>`
  height: ${getFontSize};
`;
